module.exports = __webpack_public_path__ + "static/img/10.69916c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/zh/10.png
// module id = 4keh
// module chunks = 0